import { UseFormReturn } from "react-hook-form";

import Grid from "@mui/material/Grid";

import {
  FormDateField,
  FormTextField,
  FormEmailAutocorrect,
  FormPolicyholderOrganizationTypeSelect,
  FormPolicyholderOrganizationRelationshipSelect,
} from "@covertree/ui";

import FormPhoneField from "@covertree/ui/forms/FormPhoneField";
import { PersonalDetailsWithExtraQuestionsForm } from "@covertree/new-business-forms";

import { OrganizationType } from "@covertree/new-business-graphql";
import { useHideEmailSuggestionOnScroll } from "@hooks/scroll/useHideEmailSuggestionOnScroll";

interface Props {
  form: UseFormReturn<PersonalDetailsWithExtraQuestionsForm>;
}

export function PolicyholderOrganizationFormFields({ form }: Props) {
  const { hideSuggestion } = useHideEmailSuggestionOnScroll("email-field");

  const { control, setValue, watch } = form;

  const organizationType = watch("orgType");
  const noEmail = watch("noEmail");

  return (
    <>
      <Grid item md={6}>
        <FormTextField
          id="organization-name"
          dataTestId="organization-name"
          name="orgName"
          label="Organization name"
          control={control}
        />
      </Grid>
      <Grid item md={6}>
        <FormPolicyholderOrganizationTypeSelect control={control} />
      </Grid>
      {organizationType === OrganizationType.NotListed && (
        <Grid item xs={12}>
          <FormTextField
            id="describe-org_type"
            name="describeOrgType"
            control={control}
            label="Describe organization type"
            placeholder="Describe the organization in a few words"
          />
        </Grid>
      )}
      <Grid item xs={6}>
        <FormPhoneField
          id="phone-number"
          dataTestId="phone-number-input"
          name="primaryContactNumber"
          label="Organization phone number"
          control={control}
        />
      </Grid>
      <Grid item xs={6}>
        <FormPhoneField
          id="second-phone-number"
          dataTestId="second-phone-number-input"
          name="secondaryContactNumber"
          label="Secondary phone number"
          control={control}
          optional
        />
      </Grid>
      <Grid item md={6}>
        <FormTextField
          id="first-name"
          dataTestId="first-name-input"
          name="firstName"
          label="Representative first name"
          control={control}
        />
      </Grid>
      <Grid item md={6}>
        <FormTextField
          id="last-name"
          dataTestId="last-name-input"
          name="lastName"
          label="Representative last name"
          control={control}
        />
      </Grid>
      <Grid item md={6}>
        <FormDateField
          id="date-of-birth"
          dataTestId="birth-date"
          name="insuredDateOfBirth"
          label="Representative date of birth"
          control={control}
        />
      </Grid>
      <Grid item md={6}>
        <FormPolicyholderOrganizationRelationshipSelect control={control} />
      </Grid>

      <Grid item xs={12}>
        <FormEmailAutocorrect
          id="email-field"
          dataTestId="email-input"
          name="emailAddress"
          label="Organization email"
          control={control}
          setValue={setValue}
          hideSuggestion={hideSuggestion}
          disabled={noEmail}
        />
      </Grid>
    </>
  );
}
